/* eslint-disable no-useless-catch */
import { serialize } from 'utils';

import { FindOptions } from './common';
import { entityService, stockService } from './services';

const pathname = '/stocks';

export const StockApi = {
  filter: async (option: FindOptions) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  select: async () => {
    const url = `${pathname}/select`;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkDuplicate: async (option?: CheckDuplicateStockCodeQuery) => {
    let url = `${pathname}/check-duplicate`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await stockService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanCreateStock: async (option?: CheckCanCreateStockCodeQuery) => {
    let url = `${pathname}/check-can-create-stock`;
    const query = serialize(option || {});
    url += query;
    try {
      const response = await stockService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  generateCode: async () => {
    const url = `${pathname}/generate-code`;
    try {
      const response = await stockService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  initStock: async () => {
    const url = `${pathname}/init-stock`;

    try {
      const response = await stockService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  quicklyInitStockForChain: async () => {
    const url = `${pathname}/quickly-init-stock-for-chain`;

    try {
      const response = await stockService.post(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStock: async () => {
    const url = `${pathname}/entity`;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInventoryItemWithProductID: async (id: string, option) => {
    let url = `${pathname}/find-inventory-info-with-product/${id}`;

    const query = serialize(option);
    url += query;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInventoryItemInfo: async (id: string) => {
    const url = `${pathname}/find-inventory-info/${id}`;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInventoryItemInfoWithUnit: async body => {
    const url = `${pathname}/find-inventory-info-with-current-unit`;

    try {
      const response = await stockService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  exchangeInventoryItem: async (id: string, body: any) => {
    const url = `${pathname}/exchange-inventory-item/${id}`;

    try {
      const response = await stockService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  createStock: async (data: CreateStockBody) => {
    try {
      const response = await stockService.post(pathname, data);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStock: async (id: string, data: UpdateStockBody) => {
    try {
      const response = await stockService.patch(`${pathname}/${id}`, data);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInventoryHistory: async (id: string, option: any) => {
    try {
      let url = `${pathname}/find-inventory-history-with-product/${id}`;

      const query = serialize(option || {});
      url += query;

      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStockForCreateProduct: async () => {
    try {
      const response = await stockService.get(
        `${pathname}/find-stock-for-create-product`
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  findStockForInheritStock: async option => {
    try {
      let url = `${pathname}/select-for-setting`;
      const query = serialize(option || {});
      url += query;

      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findParentsStock: async (id: string) => {
    try {
      const url = `${pathname}/find-parent-stock/${id}`;

      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteStock: async (id: string) => {
    try {
      const response = await stockService.delete(`${pathname}/${id}`);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneWithRefInfo: async (option: any) => {
    let url = `${pathname}/find-one-with-ref-info`;
    const query = serialize(option);
    url += query;

    try {
      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findInventoryItemWithUnit: async (id: string) => {
    try {
      const url = `${pathname}/find-inventory-info-with-unit/${id}`;

      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityDocumentSubCategoryForStock: async () => {
    try {
      const url = `${pathname}/entity-document-sub-category`;

      const response = await stockService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDetailCommittedForInventoryItem: async ({
    id,
    body,
    option,
  }: {
    id: string;
    body: any;
    option: any;
  }) => {
    try {
      let url = `${pathname}/detail-committed/${id}`;

      const query = serialize(option);
      url += query;

      const response = await stockService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDetailOnwayForInventoryItem: async ({
    id,
    body,
    option,
  }: {
    id: string;
    body: any;
    option: any;
  }) => {
    try {
      let url = `${pathname}/detail-onway/${id}`;

      const query = serialize(option);
      url += query;

      const response = await stockService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findDetailIncommingForInventoryItem: async ({
    id,
    body,
    option,
  }: {
    id: string;
    body: any;
    option: any;
  }) => {
    try {
      let url = `${pathname}/detail-incoming/${id}`;

      const query = serialize(option);
      url += query;

      const response = await stockService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStockType: async (id: string, body: any) => {
    try {
      const url = `${pathname}/switch-type/${id}`;

      const response = await stockService.patch(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStockSupplier: async (
    billID: string,
    body: UpdateStockCustomerBody
  ) => {
    try {
      const response = await entityService.patch(
        `${pathname}/supplier/${billID}`,
        body
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStockCustomer: async (
    billID: string,
    body: UpdateStockCustomerBody
  ) => {
    try {
      const response = await entityService.patch(
        `${pathname}/customer/${billID}`,
        body
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEntityForCreate: async () => {
    try {
      const response = await stockService.get(
        `${pathname}/find-entities-for-create`
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  findEmployeeForStock: async option => {
    try {
      let url = `${pathname}/employee-stock`;
      const query = serialize(option);
      url += query;

      const response = await stockService.get(`${url}`);

      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateStockSupplierBody {
  shouldAdjustOnHand: boolean;
  stockQuantityItems?: { billItemID: string; quantity: number }[];
}

export interface UpdateStockCustomerBody {
  shouldAdjustOnHand: boolean;
  stockQuantityItems?: { billItemID: string; quantity: number }[];
}

export interface CheckDuplicateStockCodeQuery {
  code: string;
  entityID?: string;
}

export interface CheckCanCreateStockCodeQuery {
  entityID?: string;
}

export interface CreateStockBody {
  name: string;
  code: string;
  originStockID?: string;
  entityID: string;
}

export interface UpdateStockBody {
  name: string;
  code: string;
}

// * Sử dụng để lấy thông tin đơn hàng cho các loại trạng thái trong kho
export enum INVENTORY_STOCK_TYPE {
  COMMITTED = 'COMMITTED',
  INCOMING = 'INCOMING',
  ONWAY = 'ONWAY',
}
